import { XIcon } from 'lucide-react';
import { type ButtonHTMLAttributes, forwardRef } from 'react';

import { cn } from '../../../utils';
import { RippleRoot } from '../../RippleRoot';

export const FilterChipTriggerDeleteButton = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement>
>(({ className, onClick, ...props }, ref) => {
  return (
    <button
      type="button"
      className={cn(
        'relative overflow-hidden font-medium border-l p-2 self-stretch',
        'hover:bg-secondary-accent transition-colors',
        className,
      )}
      {...props}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      ref={ref}
    >
      <XIcon className="text-secondary-foreground" size={12} />
      <RippleRoot
        className="bg-secondary-foreground"
        pulseDuration={0.4}
        pulseOpacity={0.2}
      />
    </button>
  );
});

FilterChipTriggerDeleteButton.displayName = 'FilterChipTriggerDeleteButton';
